import { render, staticRenderFns } from "./fault.vue?vue&type=template&id=3a78c63d&scoped=true&"
import script from "./fault.vue?vue&type=script&lang=js&"
export * from "./fault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a78c63d",
  null
  
)

export default component.exports